import React from "react";
import { Image as ImageIcon, FileText, Video, Music, File } from "lucide-react";
import { Pill } from "./Primitives";

const ICONS = { image: ImageIcon, pdf: FileText, text: FileText, video: Video, audio: Music, document: File };

export default function FileCard({ file, onOpen }) {
  const Icon = ICONS[file.kind] || File;
  return (
    <button
      onClick={() => onOpen(file)}
      data-testid={`file-card-${file.id}`}
      className="group flex h-full flex-col items-start gap-4 border border-edge bg-ash p-6 text-left transition-all duration-300 hover:-translate-y-1 hover:border-gold/50"
    >
      <div className="flex h-12 w-12 items-center justify-center border border-gold/40 text-gold">
        <Icon className="h-6 w-6" />
      </div>
      <div className="flex-1">
        <h3 className="font-serif text-xl text-bone group-hover:text-gold">{file.title}</h3>
        {file.description && <p className="mt-1 line-clamp-2 text-sm text-muted">{file.description}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {file.category && <Pill tone="gold">{file.category}</Pill>}
        <Pill tone="muted">{file.kind}</Pill>
      </div>
    </button>
  );
}
